import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TechnologiesService from "../../api/technologiesService";

const TechnologiesPage = () => {
  const [technologies, setTechnologies] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTechnologies = async () => {
      try {
        setLoading(true);
        const data = await TechnologiesService.getAll();
        setTechnologies(data);
      } catch (error) {
        console.error("Error fetching technologies:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTechnologies();
  }, []);

  const handleAddTechnology = () => {
    navigate("/admin/technologies/new");
  };

  const handleEditTechnology = (id) => {
    navigate(`/admin/technologies/edit/${id}`);
  };

  const handleDeleteTechnology = async (id) => {
    if (window.confirm("Are you sure you want to delete this technology?")) {
      try {
        await TechnologiesService.delete(id);
        setTechnologies(technologies.filter((tech) => tech.id !== id));
      } catch (error) {
        console.error("Error deleting technology:", error);
      }
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h4" component="h1">
          Technologies
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleAddTechnology}
        >
          Add New Technology
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Icon</TableCell>
              <TableCell>Projects</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {technologies.length > 0 ? (
              technologies.map((tech) => (
                <TableRow key={tech.id}>
                  <TableCell>{tech.name}</TableCell>
                  <TableCell>
                    {<img width="64" src={tech.icon} alt={tech.name} /> ||
                      "No icon"}
                  </TableCell>
                  <TableCell>
                    {tech.projects?.length || 0}{" "}
                    {tech.projects?.length === 1 ? "project" : "projects"}
                  </TableCell>
                  <TableCell>
                    <Button
                      size="small"
                      onClick={() => handleEditTechnology(tech.id)}
                      sx={{ mr: 1 }}
                    >
                      Edit
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      onClick={() => handleDeleteTechnology(tech.id)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} sx={{ textAlign: "center" }}>
                  No technologies found. Create your first technology!
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TechnologiesPage;
